module.exports = __webpack_public_path__ + "static/img/icon-logo.0d61830.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-logo.svg
// module id = TLSU
// module chunks = 10